import { Suspense, useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box } from '@mui/material/';
import { ToolContext } from '../core/context/ToolContext';
import { WebRoute } from "../core/webrouter/pslRoute";
import { SnakeLoader } from '../core/loader/SnakeLoader'
import { PslLogo } from '../core/global/Icons';
import { InstallPromotion } from './components/layouts/installation/InstallPromotion';
import { rqx } from '../core/request/API';
import { env } from '../core/Env';
import { BrandLog } from '../core/global/BrandLog';
import moment from 'moment/moment';
import axios from 'axios';
import { isTablet, isMobile } from 'react-device-detect';
import { VM } from '../core/VM';
import DPersonalization from './components/personalization/Index';
import MPersonalization from './components/personalization/devices/mobile/Index'
import { RegisterNotification } from '../core/global/notification/RegisterNotification';

const __SESSION = JSON.parse(localStorage.getItem('ptx_psl_session'))
const tool_id =  process.env.REACT_APP_TID_PSL;
const view = VM()

export const Core = () => {
	const { tool_state, install_state } = useContext(ToolContext)
	
	// const __installer = () => {
	// 	window.addEventListener('beforeinstallprompt', (e) => {
	// 		e.preventDefault();
	// 		install_state.prompt.set(e)
	// 		installPromptHandler()
	// 	});
	// }

	const installPromptHandler = () => {
		setTimeout(() => {
			// install_state.ip.set({stat: true, prompt_type: 'first_prompt'})
		}, 2000);
	}
	
	const __runactiveuser = async() => {
		const res = await axios.get("https://ipapi.co/json/");
		const location = JSON.stringify(res.data)
		const ipaddress = res.data.ip
		
		let data = {
			action: "signin",
			aid: __SESSION.ainfo.aid,
			date: moment(new Date()).format('YYYY-MM-DD'),
			tool_id: JSON.parse(tool_id),
			location:location,
			ip_address:ipaddress,
			device_type: isMobile? 2 : isTablet ? 3 : 1
		}
		await rqx.post(`<<global>>/${env()==='local'?'dev':env()}/trail/create`, data)
	}
	

	// console.log(parseInt(window.atob(__SESSION.data.ainfo.aid).slice(8)));
	useEffect(() => {		
		BrandLog()
		const __init = async () => {
			// RUN AN API REQUEST HERE ( SAMPLE REQUESTS BELOW: )
			let ainfo = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/account/read`, {aid: __SESSION.ainfo.aid})
			let pinfo = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/primeinfo/read`, {aid: __SESSION.ainfo.aid})
			let uaccess = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/roleaccess/uap`, {aid: __SESSION.ainfo.aid, tid:tool_id})
			let uaddress = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/location/assigned`, {aid:__SESSION.ainfo.aid})			
			await tool_state.__SESSION.set({ainfo, pinfo, uaccess, uaddress})
			
			// SET STATES HERE ( SAMPLE STORING BELOW: )
			let d = new Date()
			d.setDate(d.getDate() + 30);
			localStorage.setItem('ptx_psl_session', JSON.stringify({expiration: `${d.getMonth()+1}${d.getUTCDate()}${d.getUTCFullYear()}`, ainfo: ainfo}))
			tool_state.userId.set(parseInt(window.atob(__SESSION.ainfo.aid).slice(8)))
			
			tool_state.prefetch.set(true)
			// RUN PWA INSTALLATION PROMPT HANDLER
			// installPromptHandler()
						
			RegisterNotification(parseInt(window.atob(__SESSION.ainfo.aid).split('_')[1]), parseInt(tool_id))
		}
		
		if (__SESSION !== null) {
			// __installer()
			__init()
			__runactiveuser()
		} else {
			setTimeout(() => {
				// SET STATES HERE ( SAMPLE STORING BELOW: )
				tool_state.prefetch.set(true)

				// RUN PWA INSTALLATION PROMPT HANDLER
				
				installPromptHandler()
			}, 1000);
		}
		
		console.log(`Philtaxes Personal Version V1.10.4 is running`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Box width="100%" height="100%" >
			{
				tool_state.prefetch.data ? (
					<Router>
						<Suspense fallback={
							<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
								<PslLogo size={60}/>
								<Box mt={4}>
									<SnakeLoader size="1rem" bg="#3D77E9" distance="0.3rem" />
								</Box>
							</Box>
						}>
							<WebRoute />
							{view === '' ? (<DPersonalization/>) : (<MPersonalization/>)}
						</Suspense>
					</Router>
				) : (
					<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
						<PslLogo size={60}/>
						<Box mt={4}>
							<SnakeLoader size="1rem" bg="#3D77E9" distance="0.3rem" />
						</Box>
					</Box>
				)
			}
			<InstallPromotion install_state={install_state} />
		</Box>
	)
}